import Vue from 'vue';
import { common } from '@tencent/ceiba-base-components';

let loginManagerInstance = null;

export default class LoginApp {
  async initLogin() {
    console.log('LoginApp initLogin');
    return await new Promise((resolve) => {
      window.iUseQQConnect = 1; // 超核APP内只有qc登录，且qc登录的cookie是qq
      if (Vue.prototype.$miloLoginManager) {
        const loginInitParam = {
          commonParams: {
            iUseQQConnect: window.iUseQQConnect,
            useAppLogin: ['tgclub'],
          },
          mobileParams: {
            oWXParams: {
              gameDomain: 'supercore.qq.com',
              appId: 'wxcdd0e34a3018412d', // 超核派app
              scope: 'snsapi_userinfo',
              sUrl: location.href,
            },
            oQQConnectParams: {
              appId: '101953479', // 超核派app
              redirectUri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
              sUrl: location.href,
            },
          },
        };
        loginManagerInstance = new Vue.prototype.$miloLoginManager(loginInitParam);
        console.log('supercore initLogin done instance=', loginManagerInstance);
        resolve();
      } else {
        // todo 以上稳定后删除此逻辑
        // 过渡期兼容旧的cdn版本
        const loginInitParam = {
          appConfig: {
            gameDomain: 'supercore.qq.com',
            WxAppId: 'wxcdd0e34a3018412d',
            scope: 'snsapi_userinfo',
          },
          oQQConnectParams: {
            appId: '101953479',
          },
          iUseQQConnect: window.iUseQQConnect,
        };
        window.need('biz.login', (LoginManager) => {
          LoginManager.init(loginInitParam);
          loginManagerInstance = LoginManager;
          console.log('supercore initLogin done |loginInitParam=', loginInitParam, '|instance=', loginManagerInstance);
          resolve();
        });
      }
    });
  }
  async login(params) {
    console.log('LoginApp login|params=', params);
  }
  async checkLogin(params) {
    console.log('LoginApp checkLogin|params=', params);
    return await new Promise((resolve) => {
      if (Vue.prototype.$miloLoginManager) {
        loginManagerInstance.checkLogin().then((res) => {
          const { isLogin, userInfo } = res;
          console.log('checkRealLogin', userInfo);
          // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
          let { curPlatform } = localStorage;
          console.log('checkRealLogin curPlatform from localStorage ', curPlatform);

          if (!curPlatform) {
            curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
          }
          console.log('checkRealLogin curPlatform ', curPlatform);
          resolve({
            isLogin,
            userInfo,
          });
        })
          .catch((err) => {
            console.error('checkRealLogin Failed Code:', err.errCode);
            console.error('checkRealLogin Failed info:', err.errInfo);
            resolve({
              isLogin: false,
              userInfo: {},
            });
          });
      } else {
        // todo 以上稳定后删除此逻辑
        // 过渡期兼容旧的cdn版本
        loginManagerInstance.checkLogin((userInfo) => {
          console.log('checkLogin success userInfo=', userInfo);
          if (userInfo.loginType === 'wx') {
            const getUserInfoParam = {
              openid: common.tool.getCookie('openid'),
              access_token: common.tool.getCookie('access_token'),
              lang: 'zh_CN',
            };
            console.log('getUserInfoByWxOpenId=', getUserInfoParam);
            loginManagerInstance.getUserInfoByWxOpenId(getUserInfoParam, (wxUserInfo) => {
              console.log('登录成功，wx用户信息为', wxUserInfo);
              // eslint-disable-next-line no-param-reassign
              userInfo.avatar = wxUserInfo.headimgurl ? `${wxUserInfo.headimgurl}/64` : '';
              // eslint-disable-next-line no-param-reassign
              userInfo.nickName = wxUserInfo.nickname;
              resolve({
                isLogin: true,
                userInfo,
              });
            }, (err) => {
              console.log('获取用户信息失败', err);
              resolve({
                isLogin: false,
                userInfo: {},
              });
            });
          } else {
            // eslint-disable-next-line no-param-reassign
            userInfo.nickName = userInfo.nickname || '';
            loginManagerInstance.getUserFace((sAvatar) => {
              console.log('获取用户QQ头像信息 ', sAvatar);
              // eslint-disable-next-line no-param-reassign
              userInfo.avatar = typeof sAvatar === 'string' ? sAvatar : sAvatar.userFace;
              resolve({
                isLogin: true,
                userInfo,
              });
            });
          }
        }, (error) => {
          console.log('checklogin fail|error=', error);
          resolve({
            isLogin: false,
            userInfo: {},
          });
        });
      }
    });
  }
  async logout(params) {
    console.log('LoginApp logout|param=', params);
  }
}
